/* eslint-disable */
import React, { useState } from "react"
import { useForm, Controller } from 'react-hook-form';
import TextField from '../TextFieldCustom';
import CheckBox from '../CheckboxCustom';
import Select from '../Select';
import Button from '../Button';
import { useSubmitForm } from '../../hooks/hook.submit-form';
import provinceItaliane from '../../assets/province-italiane.json';
import FormOspedaliAmici from "./form.ospedali-amici"

const checkboxGroup = [
  {
    value: 'UNICEF EDUCATION LAB',
    label: 'Unicef education lab'
  },
  {
    value: 'EDUCATION 4 EQUALITY (3-8 anni)',
    label: 'Education 4 equality (3-8 anni)'
  },
  {
    value: 'NON PERDIAMOCI DI VIST@ (5-19 anni)',
    label: 'Non perdiamoci di vist@ (5-19 anni)'
  },
  {
    value: "L'ALBERO DEI DIRITTI (4-19 anni)",
    label: "L'albero dei diritti (4-19 anni)"
  },
  {
    value: "ALLA FINE DEL VIAGGIO. L'AZIONE DELL'UNICEF PER I BAMBINI MIGRANTI E RIFUGIATI (target 7-19 ANNI)",
    label: "Alla fine del viaggio. L'azione dell'UNICEF per i bambini migranti e rifugiati (target 7-19 anni)"
  },
  {
    value: 'GLI OBIETTIVI DI SVILUPPO SOSTENIBILE (target 7-19 ANNI)',
    label: 'Gli obiettivi di sviluppo sostenibile (target 7-19 anni)'
  },
  {
    value: 'MOMO E IL TEMPO: IMMAGINARE ED ESPLORARE GLI SPAZI ABITATI (target 7-19 anni)',
    label: 'Momo e il tempo: immaginare ed esplorare gli spazi abitati (target 7-19 anni)'
  },
  {
    value: 'LEGGERE I DIRITTI ATTRAVERSO IMMAGINI E PAROLE (target 3 - 19 anni)',
    label: 'Leggere i diritti attraverso immagini e parole (target 3-19 anni)'
  },
  {
    value: 'PROGETTO UNICEF TEATRO (5-19 anni)',
    label: 'Progetto UNICEF teatro (5-19 anni)'
  },
  {
    value: 'A SCUOLA CON GLI SCACCHI (8-14 anni)',
    label: 'A scuola con gli scacchi (8-14 anni)'
  },
];

const FormScuolaProposteEducative = ({ setShowThankYouPage, disclaimer }) => {
  const {
    handleSubmit,
    register,
    errors,
    control,
  } = useForm({
    mode: 'onFocus'
  });

  const [loadingOnSubmit, setLoadingOnSubmit] = useState({
    label: 'Invia',
    disabled: false
  });

  const onSubmit = (data) => {
    setLoadingOnSubmit({
        label: 'Sto Inviando',
        disabled: true
      }
    );
    useSubmitForm(
      data,
      434,
      () => setShowThankYouPage(true),
      () => {
        setLoadingOnSubmit({
            label: 'Invia',
            disabled: false
          }
        );
        alert('Ops, errore di rete, ritenta l\'invio');
      }
    );
  };

  return (
    <form noValidate className="form-group form-scuola" onSubmit={handleSubmit(onSubmit)}>
      <div className="form-group__container">
        <h3 className="form-group__title heading-md">Scuola - Proposte educative</h3>

        <h4 className="form-group__subtitle heading-md">Dati della scuola</h4>
        {/** NAME */}
        <TextField
          className="form-group__textfield"
          type="text"
          name="Nome Istituto Scolastico"
          label="Nome dell'istituto scolastico"
          error={errors['Nome Istituto Scolastico'] ? errors['Nome Istituto Scolastico'].message : ''}
          required
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 3,
              message: 'Il nome deve essere almeno di 3 cifre',
            }
          })}
        />

        {/** ADDRESS */}
        <TextField
          type="text"
          id="indirizzo"
          name="Indirizzo Completo"
          label="Indirizzo Completo"
          className="form-group__textfield"
          required
          error={errors['Indirizzo Completo'] ? errors['Indirizzo Completo'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** CAP */}
        <TextField
          type="text"
          id="cap"
          name="Cap"
          label="CAP"
          className="form-group__textfield"
          required
          error={errors['Cap'] ? errors['Cap'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        <h4 className="form-group__subtitle heading-md">Città</h4>

        {/** PROVINCE */}
        <Controller
          control={control}
          name="Provincia"
          rules={{ required: 'Campo obbligatorio' }}
          render={({ onChange }) => (
            <Select
              className="form-group__select"
              label="Provincia"
              name="Provincia"
              options={provinceItaliane}
              handleChange={(value) => onChange(value)}
              error={errors['Provincia'] ? errors['Provincia'].message : ''}
              required
            />
          )}
        />

        <TextField
          type="text"
          name="Comune"
          label="Comune"
          className="form-group__textfield"
          required
          error={errors['Comune'] ? errors['Comune'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio'
          })}
        />

        {/** TELEPHONE */}
        <TextField
          type="text"
          label="Telefono"
          name="Telefono"
          required
          className="form-group__textfield"
          error={errors['Telefono'] ? errors['Telefono'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 5,
              message: 'Il numero deve essere almeno di 5 cifre',
            },
            pattern: {
              value: /[+0-9]+/,
              message: 'Il formato non corrisponde'
            }
          })}
        />

        <h4 className="form-group__subtitle heading-md">Insegnante referente</h4>
        {/** NAME */}
        <TextField
          className="form-group__textfield"
          type="text"
          name="Nome"
          label="Nome"
          error={errors['Nome'] ? errors['Nome'].message : ''}
          required
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 3,
              message: 'Il nome deve essere almeno di 3 cifre',
            }
          })}
        />

        {/** SURNAME */}
        <TextField
          className="form-group__textfield"
          type="text"
          label="Cognome"
          name="Cognome"
          error={errors['Cognome'] ? errors['Cognome'].message : ''}
          required
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 3,
              message: 'Il cognome deve essere almeno di 3 cifre',
            }
          })}
        />

        {/** TELEPHONE */}
        <TextField
          type="text"
          label="Telefono"
          name="Telefono"
          required
          className="form-group__textfield"
          error={errors['Telefono'] ? errors['Telefono'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio',
            minLength: {
              value: 5,
              message: 'Il numero deve essere almeno di 5 cifre',
            },
            pattern: {
              value: /[+0-9]+/,
              message: 'Il formato non corrisponde'
            }
          })}
        />

        {/** EMAIL */}
        <TextField
          className="form-group__textfield"
          type="text"
          label="Email"
          name="Email"
          required
          error={errors['Email'] ? errors['Email'].message : ''}
          inputRef={register({
            required: 'Campo obbligatorio',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Formato email non valido'
            }
          })}
        />

        <p className="form-group__title-multiselect paragraph">Indica la proposta didattica alla quale sei interessato (potrai comunque accedere a tutti i soggetti)</p>
        {
          checkboxGroup.map((checkbox) => {
            return (
              <CheckBox
                variant="white"
                name="Proposta Didattica"
                value={checkbox.value}
                label={checkbox.label}
                inputRef={register()}
                className="form-group__checkbox form-scuola__checkbox"
              />
            );
          })
        }

        {/** PRIVACY POLICY */}
        <div className="paragraph-small" dangerouslySetInnerHTML={{__html: disclaimer}} />
        <div className="form-group__privacy">
          {/** SUBMIT BUTTON */}
          <Button type="submit" kind="primary" disabled={loadingOnSubmit.disabled} label={loadingOnSubmit.label} color="brand" />
        </div>
      </div>
    </form>
  );
};

FormScuolaProposteEducative.defaultProps = {
  disclaimer:
    '          <strong>Informativa ex art.13, GDPR</strong>\n' +
    '\n' +
    '          <p>Titolare del trattamento dei dati è il Comitato Italiano per l’UNICEF - Fondazione ONLUS , Via Palestro 68, 00185 Roma (RM).\n' +
    '            I dati personali saranno trattati con modalità prevalentemente elettroniche per le seguenti finalità:</p>\n' +
    '          <ul>\n' +
    '            <li>a) Inviare il materiale richiesto e/o dare riscontro alle richieste avanzate per l’adesione al Percorso di interesse</li>\n' +
    '            <li>b) Ottemperare a norme di legge o regolamento</li>\n' +
    '            <li>c) Fornire informazioni su iniziative/programmi di sensibilizzazione e promozione dei diritti dei bambini</li>\n' +
    '          </ul>\n' +
    '          <p>Per le finalità ai punti a) e b), il trattamento dei dati è ammesso senza il consenso dell’interessato ai sensi dell’art. 6 comma 1, lett. b) e c)\n' +
    '            GDPR; i dati saranno conservati per il tempo necessario a rispondere alle richieste e per eventuali contatti di approfondimento che permettano di\n' +
    '            valutare se aderire all’ iniziativa di interesse; in ogni caso per il periodo consentito dalla legge per esigenze di tutela legale. Per le finalità al\n' +
    '            punto c) il trattamento è ammesso ai sensi dell’art. 6 comma 1 lettera f) GDPR (“legittimo interesse”); i dati verranno conservati per il periodo\n' +
    '            consentito dalla legge per esigenze di tutela legale; la conservazione può essere di tempo inferiore se non si ha più\n' +
    '            interesse ad essere informati e lo si comunica con le modalità sotto riportate.</p>\n' +
    '          <p>Per i predetti fini saranno conservati anche successivamente, laddove leggi, regolamenti o normativa comunitaria ne determinino\n' +
    '            la conservazione per tempi differenti. Inoltre, saranno conservati in caso di imposizione da parte delle Forze dell’Ordine,\n' +
    '            della Magistratura e Organi di Controllo e per far valere o difendere diritti in sede giudiziaria. Le persone autorizzate al trattamento sono\n' +
    '            gli addetti all’amministrazione e organizzatori dell’iniziativa, alle attività istituzionali e statutarie, dei sistemi informativi e di sicurezza dei dati.</p>\n' +
    '          <p>Ai sensi degli artt. 15-22, GDPR, scrivendo all’e-mail <a href="mailto:infoprivacy@unicef.it">infoprivacy@unicef.it</a>,\n' +
    '            si può richiedere l’elenco completo e aggiornato dei responsabili del trattamento, nonché esercitare i diritti di consultazione,\n' +
    '            modificazione, di cancellazione e oblio, limitazione del trattamento dei dati, portabilità dei dati o opporsi al loro trattamento. Inoltre,\n' +
    '            l’interessato ha diritto di presentare reclamo all’autorità di controllo – per l’Italia è il Garante per la protezione dei dati personali\n' +
    '            – <a href="https://www.garanteprivacy.it">www.garanteprivacy.it</a>, per far valere i propri diritti. Il Data Protection Officer\n' +
    '            è contattabile all’e-mail <a href="mailto:dpo@unicef.it">dpo@unicef.it</a>, per informazioni sul trattamento dei dati.</p>\n' +
    '\n' +
    '          Informativa completa al sito <a href="https://www.unicef.it/note-sulla-privacy">www.unicef.it/privacy</a>\n'
}

export default FormScuolaProposteEducative;
